import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-play-video-dialog',
  templateUrl: './play-video-dialog.component.html',
  styleUrls: ['./play-video-dialog.component.scss']
})
export class PlayVideoDialogComponent implements OnInit {
  @ViewChild('playVideo') playVideo: ElementRef;
  url;
  height: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<PlayVideoDialogComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  ngOnInit() {
    if (this.data) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    }
  }
  toggleVideo(): void {
    this.playVideo.nativeElement.play();
  }

}
